import script from "./FeedItem.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedItem.vue?vue&type=script&setup=true&lang=js"

import "./FeedItem.vue?vue&type=style&index=0&id=5ea044eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ea044eb"]])

export default __exports__